export const UPDATE_WEAK = 'UPDATE_WEAK';
export const UPDATE_ONLINE = 'UPDATE_ONLINE';
export const RESET_NETWORK = 'RESET_NETWORK';
export const SAVE_USER_INFO = 'SAVE_USER_INFO';
export const UPDATE_OFFLINE = 'UPDATE_OFFLINE';
export const RESET_FOLLOWING = 'RESET_FOLLOWING';
export const RESET_ALL_NETWORK = 'RESET_ALL_NETWORK';
